module.exports = __webpack_public_path__ + "img/left_layout_icon.725a5c0e.svg";